module.exports = __webpack_public_path__ + "static/flags/TR-af02ba2ec012c3e7d4dee7334dcd2a4d.gif";